import { render, staticRenderFns } from "./creator-point.vue?vue&type=template&id=48ff4e64&scoped=true&lang=pug&"
import script from "./creator-point.vue?vue&type=script&lang=js&"
export * from "./creator-point.vue?vue&type=script&lang=js&"
import style0 from "./creator-point.vue?vue&type=style&index=0&id=48ff4e64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ff4e64",
  null
  
)

export default component.exports